"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var undo_redo_html_1 = __importDefault(require("./undo-redo.html"));
require("./undo-redo.less");
(function (module) {
    module.component('prUndoRedo', {
        bindings: {},
        templateUrl: undo_redo_html_1.default
    });
})(angular.module('qualtrics.pr'));
